import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import UserList from "../../../components/shared/UserList/UserList";
import { type IUser } from "../../../components/shared/UserList/UserList.types";

const CrewSetUp = () => {
  const navigate = useNavigate();

  const handleCreateUser = useCallback(() => {
    navigate("/settings/userlist/create-user");
  }, [navigate]);

  const handleEditUser = useCallback(
    (user: IUser) => {
      navigate(`/settings/userlist/edit-user/${user.userid}`);
    },
    [navigate],
  );

  return (
    <UserList
      onUserSelect={handleEditUser}
      onAddUser={handleCreateUser}
      showAddButton
      useManagementLinksIfAvailable
      showChangeMultiple
    />
  );
};

export default CrewSetUp;
